import { gsap } from 'gsap'
import { deepMerge } from 'js/utils/Utils'
import BaseSlideshow from 'js/modules/_base/ui/slideshow/BaseSlideshow'

const defaults = {}

export default class HomeFadeSlideshow extends BaseSlideshow {
  constructor(options = {}) {
    super()

    this.callback = {
      next: async () => {
        await new Promise((resolve) => {
          this.$items.forEach(($item, index) => {
            if (index === this.numberState.next) {
              gsap.to($item, {
                opacity: 1,
                pointerEvents: 'auto',
              })
            } else {
              gsap.to($item, {
                opacity: 0,
                pointerEvents: 'none',
              })
            }
          })

          resolve()
        })
      },
      prev: async () => {
        await new Promise((resolve) => resolve())
      },
      updateIndicator: async () => {
        await new Promise((resolve) => resolve())
      },
    }

    deepMerge(this, defaults, options)
  }

  init() {
    super.init()
    this.$items.forEach(($item, index) => {
      if (index === this.numberState.current) {
        gsap.set($item, {
          opacity: 1,
          pointerEvents: 'auto',
        })
      } else {
        gsap.set($item, {
          opacity: 0,
          pointerEvents: 'none',
        })
      }
    })
  }
}